import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const ClearCreatedAdLink = new ReduxAsyncAction('CLEAR_CREATED_AD_LINK');

ClearCreatedAdLink.registerRequest(async () => {
  return {
    createAdLink: undefined,
  };
});

export const CLEAR_CREATED_AD_LINK = ClearCreatedAdLink.actionNamespaceConstants;

export const clearCreatedAdLink = ClearCreatedAdLink.request;

export type ClearCreatedAdLinkResponseAction = Action<typeof CLEAR_CREATED_AD_LINK.response> & {
  data: {
    createAdLink: undefined;
  };
};
